import { type ReactNode } from "react";
import { Card } from "../ui/card";
import { cn } from "../../lib/utils";

export interface StatsCardProps {
  title: string;
  value: string | number;
  icon: ReactNode;
  iconColor?: "default" | "yellow" | "orange" | "green" | "blue" | "purple";
  customIconColor?: string; // Custom hex color for dynamic tier colors
  trend?: {
    value: number;
    label: string;
    isPositive?: boolean;
  };
  className?: string;
}

const iconColorClasses = {
  default: "text-muted-foreground",
  yellow: "text-yellow-400",
  orange: "text-orange-500",
  green: "text-emerald-400",
  blue: "text-blue-400",
  purple: "text-purple-400",
};

export function StatsCard({
  title,
  value,
  icon,
  iconColor = "default",
  customIconColor,
  trend,
  className,
}: StatsCardProps) {
  return (
    <Card className={cn("p-6", className)}>
      <div className="flex items-start justify-between">
        <div className="space-y-2">
          <p className="text-sm font-medium text-muted-foreground uppercase tracking-wide">
            {title}
          </p>
          <p className="text-3xl font-bold text-foreground">
            {typeof value === "number" ? value.toLocaleString() : value}
          </p>
          {trend && (
            <p
              className={cn(
                "text-xs",
                trend.isPositive ? "text-emerald-400" : "text-muted-foreground"
              )}
            >
              {trend.isPositive ? "+" : ""}
              {trend.value} {trend.label}
            </p>
          )}
        </div>
        <div
          className={cn("p-2", !customIconColor && iconColorClasses[iconColor])}
          style={customIconColor ? { color: customIconColor } : undefined}
        >
          {icon}
        </div>
      </div>
    </Card>
  );
}
